import { put } from "redux-saga/effects";
import { referenceEntriesAction } from "../action";
import { Client } from "../../../utils/transport";
import { SOMETHING_WENT_WRONG } from "constants/staticText";
import { notification } from "antd";

export function* fetchReferenceEntriesSaga(action) {
  const config = {
    method: "GET",
    url: `/api/v1/reference-entries/?${action.payload.query}`,
    headers: {
      ...action.payload.headers,
    },
  };
  try {
    const response = yield Client.request(config);

    yield put(
      referenceEntriesAction.fetchReferenceEntriesSuccess(response.data)
    );
  } catch (err) {
    let errorMessage = SOMETHING_WENT_WRONG;
    if (err.response?.status < 500) {
      errorMessage = err.response?.data?.errors?.[0]?.detail;
    }
    console.error("Error in fetching reference entries", err);
    yield put(referenceEntriesAction.fetchReferenceEntriesFailed(errorMessage));
  }
}

export function* createReferenceEntrySaga(action) {
  const config = {
    method: "POST",
    url: `/api/v1/reference-entries/`,
    headers: {
      ...action.payload.headers,
    },
    data: action.payload.body,
  };
  try {
    const response = yield Client.request(config);

    yield put(
      referenceEntriesAction.createReferenceEntrySuccess(response.data)
    );
    notification.success({
      message: `Successfully Saved Report Template!`,
    });
  } catch (err) {
    let errorMessage = SOMETHING_WENT_WRONG;
    if (err.response?.status < 500) {
      errorMessage = err.response?.data?.errors?.[0]?.detail;
    }
    console.error("Error in creating reference entry", err);
    yield put(referenceEntriesAction.createReferenceEntryFailed(errorMessage));
  }
}

export function* updateReferenceEntrySaga(action) {
  const config = {
    method: "PUT",
    url: `/api/v1/reference-entries/${action.payload.id}`,
    headers: {
      ...action.payload.headers,
    },
    data: action.payload.body,
  };
  try {
    const response = yield Client.request(config);

    yield put(
      referenceEntriesAction.updateReferenceEntrySuccess(response.data)
    );
    notification.success({
      message: `Successfully Overwritten Report Template!`,
    });
  } catch (err) {
    let errorMessage = SOMETHING_WENT_WRONG;
    if (err.response?.status < 500) {
      errorMessage = err.response?.data?.errors?.[0]?.detail;
    }
    console.error("Error in updating reference entry", err);
    yield put(referenceEntriesAction.updateReferenceEntryFailed(errorMessage));
  }
}

export function* deleteReferenceEntrySaga(action) {
  const config = {
    method: "DELETE",
    url: `/api/v1/reference-entries/${action.payload.id}`,
    headers: {
      ...action.payload.headers,
    },
  };
  try {
    yield Client.request(config);

    yield put(
      referenceEntriesAction.deleteReferenceEntrySuccess(action.payload)
    );
    notification.success({
      message: `Successfully Deleted Report Template!`,
    });
  } catch (err) {
    let errorMessage = SOMETHING_WENT_WRONG;
    if (err.response?.status < 500) {
      errorMessage = err.response?.data?.errors?.[0]?.detail;
    }
    console.error("Error in deleting reference entry", err);
    yield put(referenceEntriesAction.deleteReferenceEntryFailed(errorMessage));
  }
}
